import { Outlet, useParams } from 'react-router';

import { useRolesMatch, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import type { BroadcastRouteParams } from '../types';
import { BroadcastUrlTypes } from '../types';

const BROADCAST_ROLES = {
  [BroadcastUrlTypes.TV]: Roles.MANAGE_TV_PRODUCTS,
  [BroadcastUrlTypes.RADIO]: Roles.MANAGE_RADIO_PRODUCTS,
};
export const BroadcastRoleChecker = () => {
  const { broadcastType } = useParams<BroadcastRouteParams>();
  const role = BROADCAST_ROLES[broadcastType];
  const hasAccess = useRolesMatch({ roles: role });

  if (!hasAccess) {
    return <Status.NotFound />;
  }

  return <Outlet />;
};
